import React from 'react';
import { noop } from 'utils/noop';
import { UNIT_VALUES, UNIT_MODIFIER_VALUES } from 'utils/relativeDateTime';
import ToFromField from './customPanelForm/ToFromField';
import BasePanel from './BasePanel';
import { getNewRangeValues } from './utils';

// type Props = {
//   /** Default unit if no unit is passed. */
//   defaultUnit: string,
//   /** The relative end date/time range. */
//   endRange: string,
//   /** Show from fields. */
//   showFrom: boolean,
//   /** Show to fields. */
//   showTo: boolean,
//   /** Display the type toggle */
//   combineToAndFrom: boolean,
//   /** The relative start date/time range. */
//   startRange: string,
//   /** Callback function when date/time range changes. */
//   onRangeChange: ({}, { value: string }) => void,
// };

export default class CustomPanel extends React.Component {
  static defaultProps = {
    combineToAndFrom: false,
    /** Default unit is day. */
    defaultUnit: UNIT_VALUES.day,
    endRange: '',
    showFrom: true,
    showTo: true,
    showTypeToggle: false,
    startRange: '',
    onRangeChange: noop,
  };

  /**
   * getNewRangeValues
   * Get new start and end ranges based on changed value.
   * @returns { Object } Object containing updated startRange and endRange.
   */
  getNewRangeValues = (value, isToField) => {
    const { defaultUnit } = this.props;
    return getNewRangeValues(value, isToField, defaultUnit);
  };

  /**
   * handleChangeFromField
   * Callback function when the relative date changes in the 'from' field.
   * @param { Object } e: The change event.
   * @param { Object } fieldProps: The props of the field containing the new value.
   * @return { void }
   */
  handleChangeFromField = (e, { value }) => {
    this.props.onRangeChange({
      ...this.getNewRangeValues(value, false),
    });
  };

  /**
   * handleChangeToField
   * Callback function when the relative date changes in the 'from' field.
   * @param { Object } e: The change event.
   * @param { Object } fieldProps: The props of the field containing the new value.
   * @return { void }
   */
  handleChangeToField = (e, { value }) => {
    const { combineToAndFrom } = this.props;
    if (combineToAndFrom && value === UNIT_MODIFIER_VALUES.now) {
      this.props.onRangeChange({
        startRange: value,
        endRange: '',
      });
    } else {
      this.props.onRangeChange({
        ...this.getNewRangeValues(value, true),
      });
    }
  };

  /**
   * handleChangeToFrom
   * Callback function when the to/from dropdown is changed.
   * @param { Object } e: The change event.
   * @param { Object } updatedProps: The updated props of the dropdown containing the new value.
   * @return { void }
   */
  handleChangeToFrom = (e, { value }) => {
    const { onRangeChange, startRange, endRange } = this.props;
    const positive = value ? '+' : '-';
    const negative = value ? '-' : '+';
    onRangeChange({
      startRange: startRange.replace(negative, positive),
      endRange: endRange.replace(negative, positive),
    });
  };

  /**
   * renderSeparateToFromField
   * Renders separate to and from fields.
   * @returns { React.Component } The form containing the to and from fields.
   */
  renderSeparateToFromField = () => {
    const { showFrom, showTo, startRange, endRange } = this.props;
    const showNow = showFrom && showTo;
    return (
      <>
        {showFrom && (
          <ToFromField
            isToField={false}
            showNow={showNow}
            onChange={this.handleChangeFromField}
            value={startRange}
          />
        )}
        {showTo && (
          <ToFromField
            isToField
            showNow={showNow}
            onChange={this.handleChangeToField}
            value={endRange}
          />
        )}
      </>
    );
  };

  /**
   * renderCombinedToFromField
   * Renders combined to and from fields.
   * @returns { React.Component } The form containing the combined to and from fields.
   */
  renderCombinedToFromField = () => {
    const { showFrom, showTo, startRange, endRange } = this.props;
    const showNow = showFrom && showTo;
    const isToField = startRange === UNIT_MODIFIER_VALUES.now;
    const value = isToField ? endRange : startRange;
    return (
      <ToFromField
        hideAppendLabel
        isToField={startRange === UNIT_MODIFIER_VALUES.now}
        showNow={showNow}
        onChange={this.handleChangeToField}
        onChangeToFrom={this.handleChangeToFrom}
        showToFromDropdown
        value={value}
      />
    );
  };

  render() {
    const { combineToAndFrom, ...otherProps } = this.props;
    return (
      <BasePanel title="Custom" {...otherProps}>
        <div>
          {!combineToAndFrom && this.renderSeparateToFromField()}
          {combineToAndFrom && this.renderCombinedToFromField()}
        </div>
      </BasePanel>
    );
  }
}
